import { BannerWrapper } from "../BannerWrapper";
import { OldUpgradeButton } from "../OldUpgradeButton";
import { UpgradeButton } from "../UpgradeButton";
import { togglesAtom } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";

type Props = {
  title: string;
  description: string;
};

/** This banner is being used by the template page (ex: app/canvas/template/lead-capture)
 *  See AiCopilotBanner for the other upgrade banner.
 *
 *  If you want this banner to show up locally, return an object in upgradeBannerPropsAtom_SUSPENDS
 * */
export function UpgradeBanner({ title, description }: Props) {
  const { isProjectNeopolitanEnabled } = useAtomValue(togglesAtom);

  return (
    <BannerWrapper title={title} description={description}>
      {isProjectNeopolitanEnabled ? (
        <UpgradeButton location="Template banner" />
      ) : (
        <OldUpgradeButton location="Template banner" />
      )}
    </BannerWrapper>
  );
}
